import LeadCreation from "../../../jsx/pages/LeadCreation";

const LeadCreationWrapper = function (props) {
  return <LeadCreation />;
};

export default constore(LeadCreationWrapper);
